module.exports = __webpack_public_path__ + "static/media/How to create account.6ed4a734.png";